import { axiosRequest, METHOD } from '@/api/default.js';
import constants from '@/constants';

// Partner link system API module
// All calls are admin-only (require can_use_admin permission).

// ---- Partners ----------------------------------------------------------------

export async function getSourceTypes() {
    const response = await axiosRequest({
        url: constants.URL.PARTNERS + '/source-types',
        method: METHOD.GET,
        requestName: 'GET SOURCE TYPES',
        isLoader: false,
    });
    return response?.source_types ?? [];
}

export async function getPartners() {
    const response = await axiosRequest({
        url: constants.URL.PARTNERS,
        method: METHOD.GET,
        requestName: constants.API_REQUEST_NAMES.GET_PARTNERS,
        isLoader: false,
    });
    return response ?? [];
}

export async function createPartner(data) {
    const response = await axiosRequest({
        url: constants.URL.PARTNERS,
        method: METHOD.POST,
        requestName: constants.API_REQUEST_NAMES.CREATE_PARTNER,
        data,
        isLoader: false,
    });
    return response;
}

export async function updatePartner(partnerId, data) {
    const url = constants.URL.PARTNER.replace('{partner_id}', partnerId);
    const response = await axiosRequest({
        url,
        method: METHOD.PATCH,
        requestName: constants.API_REQUEST_NAMES.UPDATE_PARTNER,
        data,
        isLoader: false,
    });
    return response;
}

export async function deletePartner(partnerId) {
    const url = constants.URL.PARTNER.replace('{partner_id}', partnerId);
    await axiosRequest({
        url,
        method: METHOD.DELETE,
        requestName: constants.API_REQUEST_NAMES.DELETE_PARTNER,
        isLoader: false,
    });
}

// ---- Partner Links ----------------------------------------------------------

export async function getPartnerLinks(partnerId) {
    const url = constants.URL.PARTNER_LINKS.replace('{partner_id}', partnerId);
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: constants.API_REQUEST_NAMES.GET_PARTNER_LINKS,
        isLoader: false,
    });
    return response ?? [];
}

export async function createPartnerLink(partnerId, data) {
    const url = constants.URL.PARTNER_LINKS.replace('{partner_id}', partnerId);
    const response = await axiosRequest({
        url,
        method: METHOD.POST,
        requestName: constants.API_REQUEST_NAMES.CREATE_PARTNER_LINK,
        data,
        isLoader: false,
    });
    return response;
}

export async function deletePartnerLink(partnerId, linkId) {
    const url = constants.URL.PARTNER_LINK
        .replace('{partner_id}', partnerId)
        .replace('{link_id}', linkId);
    await axiosRequest({
        url,
        method: METHOD.DELETE,
        requestName: constants.API_REQUEST_NAMES.DELETE_PARTNER_LINK,
        isLoader: false,
    });
}

export async function getPartnerLinkFunnel(partnerId, linkId, params = {}) {
    const url = constants.URL.PARTNER_LINK_FUNNEL
        .replace('{partner_id}', partnerId)
        .replace('{link_id}', linkId);
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: constants.API_REQUEST_NAMES.GET_PARTNER_LINK_FUNNEL,
        params,
        isLoader: false,
    });
    return response ?? null;
}

export async function getPartnerCohortStats(partnerId, params = {}) {
    const url = constants.URL.PARTNER_COHORT_STATS
        .replace('{partner_id}', partnerId);
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: constants.API_REQUEST_NAMES.GET_PARTNER_COHORT_STATS,
        params,
        isLoader: false,
    });
    return response ?? null;
}

export async function downloadCohortCsv(partnerId, params = {}) {
    const url = constants.URL.PARTNER_COHORT_STATS_CSV
        .replace('{partner_id}', partnerId);
    const response = await axiosRequest({
        url,
        method: METHOD.GET,
        requestName: constants.API_REQUEST_NAMES.EXPORT_PARTNER_COHORT_STATS,
        params,
        responseType: 'blob',
        isLoader: false,
    });
    return response ?? null;
}
